import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { cardSx, colors, typography } from '../constants';

/** The section's standard surface: a flat bordered panel. */
export default function Card({ children, sx, ...rest }) {
  return (
    <Paper elevation={0} sx={{ ...cardSx, p: 2, ...sx }} {...rest}>
      {children}
    </Paper>
  );
}

/** Card heading with an optional right-hand slot. */
export function CardTitle({ title, action, sx }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mb: 1.5,
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: typography.emphasis,
          fontWeight: 700,
          color: colors.foreground,
        }}
      >
        {title}
      </Typography>
      {action}
    </Box>
  );
}

/**
 * Full-width footer CTA at the bottom of a dashboard card. Tinted background,
 * brand-colored semibold label, trailing arrow.
 */
export function CardFooterButton({ label, onClick }) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: 'block',
        width: '100%',
        mt: 1.5,
        border: 'none',
        cursor: 'pointer',
        backgroundColor: colors.accent,
        borderRadius: 2.5,
        py: 1.25,
        px: 1.75,
        color: colors.primary,
        fontSize: typography.caption,
        fontWeight: 600,
        fontFamily: 'inherit',
        '&:hover': { filter: 'brightness(0.97)' },
      }}
    >
      {label} →
    </Box>
  );
}
